<template>
    <div>
        <!-- Note: Spinner removed - use CommonOverlay component for loading states instead -->
        <b-alert
            :show="this.dismissSuccessCountDown"
            dismissible
            fade
            variant="success"
            @dismissed="setDismissSuccessCountDown(0)"
            @dismiss-count-down="successCountDownChanged"
        >
            {{alertMessage2}}
        </b-alert>
        <b-alert
            :show="this.errored2"
            dismissible
            fade
            variant="danger"
            @dismissed="hideIt"
        >
            <!-- ESCAPED ON PURPOSE — do not switch back to v-html. Same reasoning as
                 ErrorDisplay.vue: this renders server-controlled error text (PatientSidebar
                 feeds it via setMessage2), and an injected <img onerror=...> executed here
                 under v-html. No caller passes markup — checked across all ~47 call sites. -->
            <span>{{ alertMessage2 }}</span>
        </b-alert>
    </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'PopupErrorDisplay',
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown']),
    ...mapMutations('alert', ['setErrored2']),

    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },

    hideIt() {
        this.setErrored2(false);
    }
  },
  computed: {
    ...mapState({
        loading2: state => state.alert.loading2,
        loaded2: state => state.alert.loaded2,
        errored2: state => state.alert.errored2,
        alertMessage2: state => state.alert.message2,
        dismissSuccessCountDown : state => state.alert.dismissSuccessCountDown, 
    }),
  }
}
</script>

<style lang="scss">

</style>